var map = {
	"./007-microphone-1.png": 1331,
	"./010-home.png": 5449,
	"./013-document-1.png": 4678,
	"./014-document.png": 4690,
	"./015-color-palette.png": 7228,
	"./017-video-camera.png": 5817,
	"./024-like.svg": 8038,
	"./1.svg": 3169,
	"./155-credit-card.svg": 8534,
	"./2.svg": 214,
	"./3.svg": 4122,
	"./4.svg": 7103,
	"./New Customer.svg": 8114,
	"./NotOpen.svg": 8012,
	"./Opened.svg": 3732,
	"./Profit.svg": 6755,
	"./SalesRevenue.svg": 8079,
	"./Sent.svg": 4477,
	"./Slack.svg": 7790,
	"./address.svg": 633,
	"./adobe.svg": 5253,
	"./arrow-left.svg": 7156,
	"./arrow-right.svg": 4908,
	"./book.svg": 5183,
	"./camera.svg": 8906,
	"./chat.svg": 5971,
	"./clipboard.svg": 9481,
	"./cloud.svg": 3288,
	"./columns.svg": 718,
	"./documentation.svg": 2815,
	"./file.svg": 6439,
	"./flat.svg": 3653,
	"./headphone.svg": 7924,
	"./iconfinder_trello_2317760.svg": 180,
	"./idea.svg": 1926,
	"./image.png": 2709,
	"./image.svg": 6324,
	"./label.png": 6887,
	"./layers.svg": 1300,
	"./left.svg": 1714,
	"./logo2.svg": 5709,
	"./logo3.svg": 4142,
	"./logo4.svg": 1251,
	"./logo5.svg": 1464,
	"./logo6.svg": 1832,
	"./logoIn.svg": 5569,
	"./paint.svg": 2179,
	"./protection.svg": 7280,
	"./quote.png": 220,
	"./repeat.svg": 6294,
	"./right.svg": 9961,
	"./strategy.svg": 1096,
	"./theme.svg": 4530,
	"./user.svg": 5521,
	"./water-fall.svg": 4725
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4542;